import React from "react";
import { useAuth } from "../lib/auth";
import { AlertTriangle } from "lucide-react";

export default function ConsentGate() {
  const { setConsent, logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1628] px-4">
      <div className="mf-card max-w-lg w-full p-8 border-2 border-[#D4AF37]/40">
        <div className="flex items-center gap-3 mb-4 text-[#D4AF37]">
          <AlertTriangle size={28} />
          <h2 className="font-display text-2xl">Warning!</h2>
        </div>
        <p className="text-[#A0B4C8] leading-relaxed mb-8">
          Data yang disajikan dan Anda masukkan di aplikasi ini bersifat
          RAHASIA dan dilindungi Undang-Undang. Gunakan aplikasi ini dengan
          bijaksana, jangan sebarkan data apapun kepada pihak yang tidak
          berkepentingan.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => setConsent(true)}
            className="mf-btn-primary flex-1"
            data-testid="consent-agree"
          >
            Setuju dan lanjutkan
          </button>
          <button
            onClick={() => logout()}
            className="mf-btn-ghost flex-1"
            data-testid="consent-logout"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
